import React from "react";

const ProjectContext = React.createContext({ projectUpdateObj: {} });

export { ProjectContext };
